module.exports = __webpack_public_path__ + "static/img-schaufenster--hintergrund-desktop-e08c4225cee0de33a3a5ca2c25117134.png";